import { render, staticRenderFns } from "./User_personalinformation.vue?vue&type=template&id=29cf5d56&style=height%3A%20100%25%3B"
import script from "./User_personalinformation.vue?vue&type=script&lang=js"
export * from "./User_personalinformation.vue?vue&type=script&lang=js"
import style0 from "./User_personalinformation.vue?vue&type=style&index=0&id=29cf5d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports